<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          {{ $t('audit.title') }}
        </h6>
      </div>

      <Menu/>

      <Search
          :filters="filters"
          :loading="isSearching"
          :monthsInYearDropdown="enums.monthsInYear"
          :yearsDropdown="yearsDropdown"
          @search="getMonthlyCalendarData"/>

      <div class="element-box mt-0">
        <div class="row mt-3">
          <div v-for="(data) in monthlyData" :key="data.format1"
               class="col-12 col-sm-6 col-md-4 col-xl-2 text-center mb-4">

            <div class="p-2 mb-3 fw-bold" style="background-color: var(--primary); color: white; border-radius: 4px">
              {{ data.format2 }}
            </div>

            <div v-for="(audit) in data.audits" :key="audit.id"
                 class="border rounded mb-2 shadow-sm audit-card">
              <router-link
                  :to="{ name: 'auditFormUpdate', params: { officeId: audit.office.id, id: audit.id } }"
                  class="text-center p-2 d-block text-decoration-none text-dark">

                <p class="fw-bold mb-1" style="font-size: 0.9rem;">{{ audit.office.name }}</p>
                <p class="text-muted mb-1" style="font-size: 0.85rem;">{{ audit.date }}</p>
                <p class="mb-0 small text-primary fw-medium">
                  {{ audit.startTime }} - {{ audit.endTime }}
                </p>

              </router-link>
            </div>
          </div>
        </div>
      </div>

<!--      <div class="element-box mt-0">-->
<!--        <div class="row mt-3">-->
<!--          <div v-for="(data) in monthlyData" :key="data.format1" class="col-2 text-center mb-4"-->
<!--               style="min-height: 200px">-->
<!--            <div class="p-1 mb-2" style="background-color: var(&#45;&#45;primary); color: white; border-radius: 4px">-->
<!--              {{ data.format2 }}-->
<!--            </div>-->

<!--            <div v-for="(audit) in data.audits" :key="audit.id" class="border mb-2">-->
<!--              <router-link-->
<!--                  :to="{ name: 'auditFormUpdate', params: { officeId: audit.office.id, id: audit.id } }"-->
<!--                  class="text-center p-1">-->
<!--                <p style="margin-bottom: 8px;">{{ audit.office.name }}</p>-->
<!--                <p style="margin-bottom: 5px;">{{ audit.date }}</p>-->
<!--                <p style="margin-bottom: 3px;">{{ audit.startTime }} - {{ audit.endTime }}</p>-->
<!--              </router-link>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </PageTemplate>
</template>

<script setup>
import officeAuditService from '@/api/OfficeAudit';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import { getYears } from '@/shared/dropdowns';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import Search from '@/views/App/OfficeAudit/Calendar/CalendarSearch.vue';
import Menu from '@/views/App/OfficeAudit/Menu.vue';
import { onMounted, ref } from 'vue';

const monthlyData   = ref([]);
const isLoaded      = ref(false);
const yearsDropdown = ref([]);
const isSearching   = ref(false);
const { enums }     = piniaEnumsStore();

const today             = new Date();
const currentMonthIndex = today.getMonth();

const filters = ref({
  year: yearsDropdown.value.at(-1)?.value || new Date().getFullYear(),
  month: enums.monthsInYear[ currentMonthIndex ].value,
});

async function getMonthlyCalendarData(passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  try {
    const { data } = await officeAuditService.getMonthlyCalendar({ ...(passedFilters ? passedFilters : filters.value) });

    monthlyData.value = data.data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getYears(yearsDropdown);
  await getMonthlyCalendarData();
  isLoaded.value = true;
});

</script>

<style scoped>
.audit-card {
  transition: transform 0.2s, box-shadow 0.2s;
  background-color: #fff;
}
.audit-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  border-color: var(--primary) !important;
}
</style>